import { render, staticRenderFns } from "./SvgPreviewSlider.vue?vue&type=template&id=5ffe2b74&"
import script from "./SvgPreviewSlider.vue?vue&type=script&lang=js&"
export * from "./SvgPreviewSlider.vue?vue&type=script&lang=js&"
import style0 from "./SvgPreviewSlider.vue?vue&type=style&index=0&id=5ffe2b74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports